import { Control } from '../Control'

export function ControlNode({ value, onChange, ...controlProps }) {
  return (
    <Control {...controlProps} value={value} onChange={onChange}>
      {value.value}
    </Control>
  )
}

export default ControlNode
